/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EditDesignProjectTile_designProject = {
    readonly serviceId: string | null;
    readonly addressDisplayString: string | null;
    readonly internalEditUrl: string | null;
    readonly editUrl: string | null;
    readonly name: string | null;
    readonly rootId: number | null;
    readonly tradeCoverPhoto: {
        readonly path: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"DesignProjectTileStatusBadge_designProject" | "DeleteProjectConfirmationModal_designProject">;
    readonly " $refType": "EditDesignProjectTile_designProject";
};
export type EditDesignProjectTile_designProject$data = EditDesignProjectTile_designProject;
export type EditDesignProjectTile_designProject$key = {
    readonly " $data"?: EditDesignProjectTile_designProject$data;
    readonly " $fragmentRefs": FragmentRefs<"EditDesignProjectTile_designProject">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditDesignProjectTile_designProject",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addressDisplayString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalEditUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rootId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhoto",
      "kind": "LinkedField",
      "name": "tradeCoverPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignProjectTileStatusBadge_designProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteProjectConfirmationModal_designProject"
    }
  ],
  "type": "designProject",
  "abstractKey": null
};
(node as any).hash = '6161146d85937476b00eeef1f713cdf8';
export default node;
